<template>
  <div>
    <div class="row evollu-form">
      <range-date-picker
        id="selected-time-date-picker"
        class="col-12 col-md-4 datesFilter"
        v-model="filters.dateRange"
        placeholder=" ---" >

        <div slot="label">
          <label class="form-label" style="margin-top: -3px;">
            {{ $t('statistics.daterange_start') }}
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'createdAt', 'selectedDateLabel': filters.date == 'createdAt'}" @click="setDate('createdAt')">{{ $t('statistics.daterange_created_at') }}</span>
            <span class="dateSeparatorLabel">/</span>
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'updatedAt', 'selectedDateLabel': filters.date == 'updatedAt'}" @click="setDate('updatedAt')">{{ $t('statistics.daterange_updated_at') }}</span>
            {{ $t('statistics.daterange_end') }}:
          </label>
        </div>

      </range-date-picker>

      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('entities.activities.revision.activity')}}:</label>
          <multiselect
            v-model="filters.activity"
            :options="activitiesOptions"
            track-by="id"
            :customLabel="elem => $t(`entities.activity_types.${elem.id}`)"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('entities.activities.revision.activity')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="activitiesOptions.length === 1 || filters.dateRange.start === null">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.activity"
                      @mousedown.prevent.stop="clearActivitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entity"
            :options="entitiesOptions"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('facility.inputs.entity')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="entitiesOptions.length === 1 || filters.activity === null">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entity"
                      @mousedown.prevent.stop="clearEntitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('agenda.appointments.facility')}}:</label>
          <multiselect
            v-model="filters.facility"
            :options="facilitiesOptions"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('agenda.appointments.facility')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="facilitiesOptions.length <= 1">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facility"
                      @mousedown.prevent.stop="clearFacilitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{ $t("agenda.appointments.appointment_type") }}:</label>
          <multiselect
            v-model="filters.bookingType"
            :options="bookingTypes"
            track-by="id"
            label="name"
            :custom-label="(elem) => $t(`activities_agenda.agenda.booking_types.${elem.slug}`)"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('agenda.appointments.appointment_type')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="!mandatoryFiltersSettedCompleted"
          >
            <template slot="clear">
                        <span class="multiselect__clear" v-if="filters.bookingType"
                              @mousedown.prevent.stop="() => filters.bookingType = null"></span>
            </template>
            <span slot="noResult">{{ "patients.noResults"| translate }}</span>
          </multiselect>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{ $t("agenda.inputs.status") }}:</label>
          <multiselect
            v-model="filters.status"
            :options="bookingStatuses"
            track-by="id"
            label="name"
            :customLabel="(elem) => $t(`activities_agenda.events.statuses.${elem.id}`)"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('agenda.inputs.status')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="!mandatoryFiltersSettedCompleted"
          >
            <template slot="clear">
                        <span class="multiselect__clear" v-if="filters.status"
                              @mousedown.prevent.stop="() => filters.status = null"></span>
            </template>
            <span slot="noResult">{{ "patients.noResults"| translate }}</span>
          </multiselect>
        </div>
      </div>

      <div class="no-data-disclaimer" v-if="!mandatoryFiltersSettedCompleted" >
        <h5> {{$t('please_select_filter_to_show_data')}} </h5>
      </div>
    </div>
    <v-server-table
      v-show="mandatoryFiltersSettedCompleted"
      :columns="columns"
      :options="tableOptions"
      id="activitiesAgendaTable"
      ref="activitiesAgendaTable"
      name="activitiesAgendaTable"
    >
      <span v-if="row.createdAt" slot="createdAt" slot-scope="{row}">
        {{ row.createdAt | localTime('YYYY-MM-DD HH:mm') }}
      </span>

      <span v-if="row.updatedAt" slot="updatedAt" slot-scope="{row}">
        {{ row.updatedAt | localTime('YYYY-MM-DD HH:mm') }}
      </span>
      <span v-if="row.originEntity && row.originEntity.name" slot="originEntity" slot-scope="{row}">
        {{ row.originEntity.name }}
      </span>
      <span v-if="row.originFacility && row.originFacility.name" slot="originFacility" slot-scope="{row}">
        {{ row.originFacility.name }}
      </span>
      <span v-if="row.entity && row.entity.name" slot="entity" slot-scope="{row}">
        {{ row.entity.name }}
      </span>
      <span v-if="row.facility && row.facility.name" slot="facility" slot-scope="{row}">
        {{ row.facility.name }}
      </span>
      <span v-if="row.start" slot="start" slot-scope="{row}">
        {{ row.start | localTime('YYYY-MM-DD HH:mm') }}
      </span>
      <span v-if="row.end" slot="end" slot-scope="{row}">
        {{ row.end | localTime('YYYY-MM-DD HH:mm') }}
      </span>
      <span v-if="row.person" slot="person" slot-scope="{row}">
        {{ row.person.firstName ? row.person.firstName + " " + row.person.lastName : "N/A" }}
      </span>
      <span slot="phone" slot-scope="{row}">
        {{ row.person.mobilePhone ? row.person.mobilePhone : "N/A" }}
      </span>
      <span v-if="row.bookingType" slot="bookingType" slot-scope="{row}">
        {{ row.bookingType.slug ? $t(`activities_agenda.agenda.booking_types.${row.bookingType.slug}`) : "N/A"}}
      </span>
      <span slot="status" slot-scope="{row}">
        {{ row.status ? $t(`activities_agenda.events.statuses.${row.status.id}`) : "N/A"}}
      </span>


    </v-server-table>

  </div>

</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import Multiselect from 'vue-multiselect';
import { ActivityService } from '@/api/AuthService';
import { uniqBy } from 'lodash';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { ActivitiesAgendaService } from '@/api/ActivitiesAgendaService';

export default {
  components: {
    Multiselect,
    RangeDatePicker,
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  mixins: [
    TableQueryMixin,
    MultiselectLabelFormatter
  ],
  data () {
    return {
      bookingTypes: [],
      entitiesOptions: [],
      facilitiesOptions: [],
      activitiesOptions: [],
      activitiesOptionsFull: [],
      bookingStatuses: [],
      columns: [
        'createdAt',
        'updatedAt',
        'originEntity',
        'originFacility',
        'entity',
        'facility',
        'start',
        'end',
        'person',
        'phone',
        'bookingType',
        'status'
      ],
      queryUrl: `${this.$store.state.activities_agenda_server}/v1/bookings/list`,
      tableOptions: {
        columnsDropdown: true,
        saveState: false,
        filterable: true,
        sortable: [],
        customFilters: ['date', 'start', 'end', 'activity', 'bookingType', 'status'],
        headings: {
          'createdAt': this.$t('activities_agenda.table.created_at'),
          'updatedAt': this.$t('activities_agenda.table.updated_at'),
          'originEntity': this.$t('activities_agenda.table.originEntity'),
          'originFacility': this.$t('activities_agenda.table.originFacility'),
          'entity': this.$t('activities_agenda.table.entity'),
          'facility': this.$t('activities_agenda.table.facility'),
          'start': this.$t('activities_agenda.table.start'),
          'end': this.$t('activities_agenda.table.end'),
          'person': this.$t('activities_agenda.table.person'),
          'phone': this.$t('people_manager.table.phone'),
          'bookingType': this.$t('activities_agenda.table.bookingType'),
          'status': this.$t('activities_agenda.table.status')
        },
        columnsClasses: {

        },
        orderBy: {
          column: 'createdAt',
          ascending: 0
        }
      },
      filters: {
        date: 'createdAt',
        dateRange: {
          start: this.moment().startOf('month').format('YYYY-MM-DD'),
          end: this.moment().endOf('month').format('YYYY-MM-DD'),
        },
        activity: null,
        entity: null,
        facility: null,
        bookingType: null,
        status: null,
      }
    }
  },
  async mounted() {
    await this.loadActivitiesOptions()
    await this.loadBookingTypes();
    await this.loadBookingStatuses();
    this.setTableDatesFilter()
  },
  methods: {
    loadActivitiesOptions: async function() {
      try {
        const response = await ActivityService.getActivitiesAgendaOptions()
        this.activitiesOptionsFull = response
        this.activitiesOptions = response.internal.map(elem => elem.activity)
        this.activitiesOptions.push(...response.external.map(elem => elem.activity))
        this.activitiesOptions = uniqBy(this.activitiesOptions, 'id')

        if(this.activitiesOptions.length === 1) {
          this.filters.activity = this.activitiesOptions[0]
        }

      } catch (err) {
        console.log(err)
        this.showToast(this.$t('entities.messages.error'), this.$store.state.errorToastOptions)
      }
    },
    loadBookingStatuses: async function() {
      try {
        this.bookingStatuses = await ActivitiesAgendaService.getAllBookingStatuses();
      } catch (e) {
        console.log(e)
      }
    },
    loadBookingTypes: async function() {
      try {
        this.bookingTypes = await ActivitiesAgendaService.getBookingTypes();
      } catch (err) {
        console.log("Error retrieving booking types")
        console.log(err);
      }
    },
    clearActivitiesMultiselect: function () {
      this.filters.activity = null
      this.clearEntitiesMultiselect()
    },
    clearEntitiesMultiselect: function () {
      this.filters.entity = null
      this.filters.facility = null
      this.facilitiesOptions = []
      //this.$refs.fullCalendar.getApi().removeAllEvents()
    },
    clearFacilitiesMultiselect: function () {
      this.filters.facility = null
    },
    setDate: function (date) {
      this.filters.date = date
      this.setTableDatesFilter()
      if(this.mandatoryFiltersSettedCompleted) {
        this.refreshTableData()
      }
    },
    setTableDatesFilter: function () {
      this.$refs.activitiesAgendaTable.customQueries.start = this.filters.dateRange.start
      this.$refs.activitiesAgendaTable.customQueries.end = this.filters.dateRange.end
      this.$refs.activitiesAgendaTable.customQueries.date = this.filters.date
    },
    refreshTableData: function () {
      this.$refs.activitiesAgendaTable.refresh()
    }
  },
  computed: {
    mandatoryFiltersSettedCompleted: function() {
      return this.filters !== undefined && this.filters.dateRange.start !== null
        && this.filters.dateRange.end !== null
        && this.filters.activity !== null
        && this.filters.entity !== null
        && this.filters.facility !== null
    }
  },
  watch: {
    'filters.dateRange': {
      handler: function (dateRange) {
        if(dateRange === null) {
          this.filters.activity = null
        } else {
          this.setTableDatesFilter()
          if(this.mandatoryFiltersSettedCompleted) {
            this.refreshTableData()
          }
        }

      },
      immediate : false
    },
    'filters.activity': {
      handler: function(activity) {
        if (activity !== null) {

          this.filters.entity = null
          this.entitiesOptions = []
          const internalActivityOption = this.activitiesOptionsFull.internal.find(elem => elem.activity.id === activity.id)
          if(internalActivityOption) {
            this.entitiesOptions = [...internalActivityOption.self_provider_entities]
          }

          const externalActivityProviders = this.activitiesOptionsFull.external.find(elem => elem.activity.id === activity.id)
          if(externalActivityProviders) {
            this.entitiesOptions.push(...externalActivityProviders.external_provider_entities)
          }
          if(this.entitiesOptions.length === 1) {
            this.filters.entity = this.entitiesOptions[0]
          }
          this.$refs.activitiesAgendaTable.customQueries.activity = activity.id
          if(this.mandatoryFiltersSettedCompleted) {
            this.refreshTableData()
          }
        } else {
          this.entitiesOptions = []
        }
      },
    },
    'filters.entity': {
      handler: function(entity) {
        if(entity !== null) {
          //Update facilities Options based on the selected entity
          this.$refs.activitiesAgendaTable.customQueries.entity = entity.id
          this.filters.facility = null
          this.facilitiesOptions = entity.facilities
          if(this.facilitiesOptions.length === 1) {
            this.filters.facility = this.facilitiesOptions[0]
          }
          if(this.mandatoryFiltersSettedCompleted) {
            this.refreshTableData()
          }
        } else {
          this.facilitiesOptions = []
        }
      }

    },
    'filters.facility': {
      handler: function(facility) {
        if(facility !== null) {
          this.filters.facility = facility
          this.$refs.activitiesAgendaTable.customQueries.facility = facility.id
          if(this.mandatoryFiltersSettedCompleted) {
            this.refreshTableData()
          }
        } else {
          this.filters.bookingType = null
        }
      }
    },
    'filters.bookingType': {
      handler: function(bookingType) {
        if(bookingType === null) {
          this.$refs.activitiesAgendaTable.customQueries.bookingType = ''
        } else {
          this.filters.bookingType = bookingType
          this.$refs.activitiesAgendaTable.customQueries.bookingType = bookingType.id
        }
        if(this.mandatoryFiltersSettedCompleted) {
          this.refreshTableData()
        }
      }
    },
    'filters.status': {
      handler: function(status) {
        if(status === null) {
          this.$refs.activitiesAgendaTable.customQueries.status = ''
        } else {
          this.filters.status = status
          this.$refs.activitiesAgendaTable.customQueries.status = status.id
        }
        if(this.mandatoryFiltersSettedCompleted) {
          this.refreshTableData()
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.unselectedDateLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: line-through !important;
}

.dateSeparatorLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.selectedDateLabel {
  font-size: 0.6rem !important;
  color: #29c4a9 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.no-data-disclaimer {
  width: 100%;
  margin: 25px;
  border-radius: 12px;
  background-color: rgb(246, 236, 221);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  h5 {
    color: #878787;
  }

}
</style>
